import { render, staticRenderFns } from "./FileImgIcon.vue?vue&type=template&id=bff82b9e&"
import script from "./FileImgIcon.vue?vue&type=script&lang=js&"
export * from "./FileImgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports